<template>
  <div>
    <section class="section-header-info middle-content">
      <div class="container big-container">
        <div class="row text-center">
          <div class="col-sm-12">
            <h3>Tenant Jobs Browser</h3>
            <div class="table-legend">
              <ul>
                <li><i class="ic-flight-icon"></i>Airport Transfer</li>
                <li><i class="ic-time"></i>Hourly Booking</li>
              </ul>
            </div>
            <div class="data-row --blue25">
              <strong>{{ time }}</strong>
            </div>
            <div class="form-group mt-20">
              <div
                class="btn-group btn-group-toggle mb-25"
                data-toggle="buttons"
              >
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'all' }"
                  @click="changePeriods('all')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'today' }"
                  @click="changePeriods('today')"
                >
                  Today
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'tomorrow' }"
                  @click="changePeriods('tomorrow')"
                >
                  Tomorrow
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'next' }"
                  @click="changePeriods('next')"
                >
                  Next Day
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-selectDate"
                  :class="{ 'btn-active': period === 'range' }"
                >
                  <VueCtkDateTimePicker
                    id="jobBrowserDateRange"
                    name="jobBrowserDateRange"
                    v-model="jobBrowserDateRange"
                    color="#025BC5"
                    format="YYYY-MM-DD"
                    formatted="MMM DD"
                    range
                    no-shortcuts
                    label="Select Date"
                    no-header
                    overlay
                    no-button-now
                    button-color="#FFB733"
                    no-clear-button
                    @is-shown="showPicker()"
                    @is-hidden="hidePicker()"
                    @validate="searchRange()"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Reservation Code"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ul class="nav nav-tabs tabs-inquiry sticky">
              <li class="active">
                <a
                  data-toggle="tab"
                  href="#job-all"
                  @click="changeProgress('all')"
                >
                  <span class="qty-jobs">{{ totalAllJobs }}</span> All
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-open"
                  @click="changeProgress('open')"
                >
                  <span class="qty-jobs">{{ totalJobsOpen }}</span> Open
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-run"
                  @click="changeProgress('run')"
                >
                  <span class="qty-jobs">{{ totalJobsRun }}</span> Run
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-under-review"
                  @click="changeProgress('underreview')"
                >
                  <span class="qty-jobs">{{ totalJobsUnderReview }}</span> Under
                  Review
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-rescue"
                  @click="changeProgress('rescueoperation')"
                >
                  <span class="qty-jobs">{{ totalJobsRescued }}</span> Rescue
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-done"
                  @click="changeProgress('done')"
                >
                  <span class="qty-jobs">{{ totalJobsDone }}</span> Done
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-close"
                  @click="changeProgress('close')"
                >
                  <span class="qty-jobs">{{ totalJobsClose }}</span> Closed
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-aborted"
                  @click="changeProgress('abort')"
                >
                  <span class="qty-jobs">{{ totalJobsAborted }}</span> Aborted
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="job-all" class="tab-pane fade in active">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Progress &amp; Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            :class="{
                              'sts_job-open': item.progress === 'Open',
                              'sts_job-run': item.progress === 'Run',
                              'sts_job-done': item.progress === 'Done',
                              'sts_job-closed': item.progress === 'Close',
                              'sts_job-aborted': item.progress === 'Abort',
                              'sts_job-rescue_operation':
                                item.progress === 'RescueOperation',
                            }"
                          ></span>
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-under-review" class="tab-pane">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Progress &amp; Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            :class="{
                              'sts_job-open': item.progress === 'Open',
                              'sts_job-run': item.progress === 'Run',
                              'sts_job-done': item.progress === 'Done',
                              'sts_job-closed': item.progress === 'Close',
                              'sts_job-aborted': item.progress === 'Abort',
                              'sts_job-rescue_operation':
                                item.progress === 'RescueOperation',
                              'sts_job-under-review':
                                item.progress === 'UnderReview',
                            }"
                          ></span>
                          <span
                            class="last_state d-flex justify-center items-center gap-5"
                          >
                            <i class="ic-checklist"></i>
                            <span v-if="item.progress === 'RescueOperation'">
                              {{
                                shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                )
                              }}
                            </span>
                            <span v-else> {{ getLastState(item) }}</span>
                          </span>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-open" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div
                            class="row-big-menu"
                            v-if="
                              isAllowToAbort ||
                              isAllowToDispatch ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  isAllowToDispatch &&
                                  $helper.isNotExpiredDate(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="getPreferredProviders(item)"
                                >
                                  <span>Dispatch</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                              <li v-if="isAllowToAbort">
                                <button
                                  class="btn btn-default sts-danger"
                                  type="button"
                                  @click="openAbortReservationDialog(item)"
                                >
                                  <span>Abort</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-run" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div
                            class="row-big-menu"
                            v-if="
                              isAllowToDispatch ||
                              isAllowToAbort ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  isAllowToDispatch &&
                                  pickUpDateExpired(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="getPreferredProviders(item)"
                                >
                                  <span>Dispatch</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                              <li
                                v-if="
                                  isShowTripLog &&
                                  (userType === 'TenantUser' ||
                                    userType === 'ProviderUser')
                                "
                              >
                                <router-link
                                  :to="`/reservation/tenant/trip-log/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-info btn btn-default"
                                >
                                  Logging
                                </router-link>
                              </li>
                              <li v-if="isAllowCompleteJob(item)">
                                <button
                                  target="_blank"
                                  class="btn btn-default --green35"
                                  @click="openModalCompleteTrip(item)"
                                >
                                  <span>Complete Job</span>
                                </button>
                              </li>
                              <li v-if="isAllowAcceptAmendment(item)">
                                <button
                                  target="_blank"
                                  class="btn btn-default --green-accept-amendment"
                                  @click="openModalAcceptAmendment(item)"
                                >
                                  <span>Accept Amendment</span>
                                </button>
                              </li>
                              <li v-if="isAllowToAbort">
                                <button
                                  class="btn btn-default sts-danger"
                                  type="button"
                                  @click="openAbortReservationDialog(item)"
                                >
                                  <span>Abort</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-rescue" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div
                            class="row-big-menu"
                            v-if="
                              (isAllowToDispatch &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              isAllowToAbort ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  isAllowToDispatch &&
                                  $helper.isNotExpiredDate(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="getPreferredProviders(item)"
                                >
                                  <span>Dispatch</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                              <li v-if="isAllowToRead">
                                <button
                                  class="sts-reserved btn btn-default"
                                  @click="handleBackToRun(item.reservationId)"
                                >
                                  <span>Back to Run</span>
                                </button>
                              </li>
                              <li v-if="isAllowToAbort">
                                <button
                                  class="btn btn-default sts-danger"
                                  type="button"
                                  @click="openAbortReservationDialog(item)"
                                >
                                  <span>Abort</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-done" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div
                            class="row-big-menu"
                            v-if="
                              isAllowToAbort ||
                              isAllowToReprice ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li v-if="isAllowToReprice">
                                <button
                                  v-if="canReprice(item)"
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="viewReservationReprice(item)"
                                >
                                  <span>Repricing</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                              <li
                                v-if="
                                  isShowTripLog &&
                                  (userType === 'TenantUser' ||
                                    userType === 'ProviderUser')
                                "
                              >
                                <router-link
                                  :to="`/reservation/tenant/trip-log/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-info btn btn-default"
                                >
                                  Logging
                                </router-link>
                              </li>
                              <li v-if="isAllowToAbort">
                                <button
                                  class="btn btn-default sts-danger"
                                  type="button"
                                  @click="openAbortReservationDialog(item)"
                                >
                                  <span>Abort</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-close" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-aborted" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th class="single-line-text">Reservation Pick-Up</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span v-else class="no-wrap">
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/tenant/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  <span>Details</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          {{
                            $helper.dateFormatted(
                              item.originalPickUpTime.dateTime
                            )
                          }}
                          <div class="d-flex items-center gap-3">
                            <strong>{{
                              $helper.timeFormatted(
                                item.originalPickUpTime.dateTime
                              )
                            }}</strong>
                            <span class="utc-style"
                              >({{ item.originalPickUpTime.timezone }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="tenant_event_modal">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Provider Dispatch</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mtz">
                  <div class="provider-search">
                    <label for="search">Search Provider</label>
                    <div class="dataTables_filter" id="filter-search">
                      <i class="ic-search"></i>
                      <input
                        id="search"
                        type="search"
                        class="form-control"
                        placeholder="Search Provider"
                        v-model="searchProvider"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <!-- Start: Table -->
                  <div class="table-modal-detail">
                    <div class="table-responsive table-accordion">
                      <table class="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>Provider</th>
                            <!-- <th>Req. Ancillaries</th>
                            <th>Status</th> -->
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in filterPreferredProviders"
                            :key="item.reservationId"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>
                              {{ item.providerName }}
                              <span
                                v-if="item.isPreffered"
                                class="badge-preferred-provider"
                                >Preferred Provider</span
                              >
                            </td>
                            <!-- <td>
                              <span
                                v-html="
                                  printRequestedAncillaries(
                                    item.requestedAncillaries
                                  )
                                "
                              ></span>
                            </td>
                            <td>{{ humanize(item.event) }}</td> -->
                            <td
                              class="text-center d-flex justify-center items-center"
                            >
                              <div
                                class="button-action-wrapper"
                                v-if="item.isDispatchAllowed"
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openManualDispatchDialog(item)"
                                >
                                  <span>Dispatch</span>
                                </button>
                              </div>
                              <div
                                class="button-action-wrapper"
                                v-if="
                                  item.isSelected && isAllowToReleaseProvider
                                "
                              >
                                <button
                                  class="btn btn-default sts-warning"
                                  type="button"
                                  @click="openReleaseProviderDialog(item)"
                                >
                                  <span>Release</span>
                                </button>
                              </div>
                              <div
                                class="button-action-wrapper"
                                v-if="
                                  hasProvider &&
                                  (!item.isSelected ||
                                    !isAllowToReleaseProvider)
                                "
                              >
                                <button
                                  class="btn btn-default --blue25"
                                  type="button"
                                  @click="
                                    reassignPreferredProvider(item.providerId)
                                  "
                                >
                                  <span>Reassign</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div>
                    <span class="sts-danger">* Ancillary Not Available</span>
                  </div>
                  <!-- End: Table -->
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <CompleteTrip @finish="changeProgress" />

    <reservationRepriceComponent></reservationRepriceComponent>

    <div class="modal fade" role="dialog" ref="cancelreasonmodal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Abort Job</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.abortModel.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="abort">
                    <div class="form-group mbz">
                      <div>
                        <strong>Tell us why you are cancelling.</strong>
                      </div>
                      <div class="btn-group-radio btn-group-newline">
                        <label
                          class="wrap-radio"
                          v-for="(item, index) in reasons"
                          @click="onClickReasonCode(item)"
                          :key="index"
                        >
                          {{ item.text }}
                          <input
                            type="radio"
                            :class="{
                              'field-error':
                                isSubmitted && $v.abortModel.reasonCode.$error,
                            }"
                            :value="item.value"
                            v-model="abortModel.reasonCode"
                          />
                          <span class="bullet-mark"></span>
                        </label>
                      </div>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.abortModel.reasonCode.required"
                        >Reason Code is required</small
                      >
                    </div>
                    <div
                      class="form-group"
                      v-if="abortModel.reasonCode === '5'"
                    >
                      <textarea
                        class="form-control"
                        :class="{
                          'field-error':
                            isSubmitted && $v.abortModel.reasonWord.$error,
                        }"
                        rows="4"
                        v-model="abortModel.reasonWord"
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="
                          abortModel.reasonWord && abortModel.reasonWord !== ''
                        "
                      >
                        {{ abortModel.reasonWord.length }} from
                        {{ $v.abortModel.reasonWord.$params.maxLength.max }}
                        characters
                      </div>
                      <div
                        v-if="isSubmitted && $v.abortModel.reasonWord.$error"
                      >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.abortModel.reasonWord.required"
                          >Reason Word is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.abortModel.reasonWord.maxLength"
                          >Reason Word must be less than
                          {{ $v.abortModel.reasonWord.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :id="'AcceptAmendment'"
      :header="'Accept Amendment'"
      :content="`Are you sure? If you decline, the Provider will be released.`"
      :cancel-label="'Decline'"
      :submit-label="'Accept'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      :closeIcon="true"
      @onCancel="handleAcceptAmendment(2)"
      @submit="handleAcceptAmendment(1)"
    />
    <confirmModal
      :id="'OverrideDispatchConfirmation'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @onCancel="cancelConfirmation()"
      @submit="manualDispatch(true)"
    />
    <confirmModal
      :id="'OverrideAcceptAmendment'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @onCancel="cancelConfirmation()"
      @submit="handleAcceptAmendment(1)"
    />
    <confirmModal
      :id="'OverrideConfirmation'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @onCancel="cancelConfirmation()"
      @submit="reassignPreferredProvider(providerId, true)"
    />
    <confirmModal
      :id="'DispatchProviderConfirmation'"
      :header="'Dispatch'"
      :content="`Are you sure you want dispatch to<br/><strong>${selectedProvider.providerName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Dispatch'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="manualDispatch"
    />
    <confirmModal
      :id="'ReleaseProviderConfirmation'"
      :header="'Release'"
      :content="`Operator Tariff will be removed. Are you sure you want release job from<br/><strong>${selectedProvider.providerName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Release'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="releaseProvider"
    />
    <confirmModal
      :id="'AbortReservationConfirmation'"
      :header="'Abort'"
      :content="`Are you sure you want abort this reservation?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Abort'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="openCancelReasonDialog"
    />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import moment from "moment";
import confirmModal from "@/components/shared/ConfirmModal";
import deleteModal from "@/components/shared/DeleteModal";
import reservationRepriceComponent from "@/components/job/tenantJob/TenantReservationReprice";
import inquiryTenantJobService from "@/services/job/tenantJob/inquiryTenantJobService.js";
import availableJobService from "@/services/job/availableJobService";
import reservationService from "@/services/shop/reservationService.js";
import CompleteTrip from "@/components/shared/CompleteTrip";
import tripLogJobService from "@/services/job/tripLogJob/tripLogJobService.js";
import { firebaseDB } from "@/plugins/firebase.js";

export default {
  components: {
    confirmModal,
    deleteModal,
    reservationRepriceComponent,
    CompleteTrip,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToDispatch: function () {
      return this.allPermissions.includes("DispatchProvider");
    },
    isAllowToReleaseProvider: function () {
      return this.allPermissions.includes("ReleaseProvider");
    },
    isAllowToAbort: function () {
      return this.allPermissions.includes("Abort");
    },
    time: function () {
      const date = new Date();
      switch (this.period) {
        case "tomorrow":
          date.setDate(date.getDate() + 1);
          break;
        case "next":
          date.setDate(date.getDate() + 2);
          break;
      }
      return moment(date).format("dddd, MMMM DD yyyy");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    isAllowToReprice: function () {
      return this.allPermissions.includes("Pricing");
    },
    isShowTripLog: function () {
      return this.allPermissions.includes("TripLog");
    },
    filterPreferredProviders: function () {
      if (!this.searchProvider) {
        return this.preferredProviders;
      }

      return this.preferredProviders.filter((val) =>
        val.providerName
          .toLowerCase()
          .includes(this.searchProvider.toLowerCase())
      );
    },
    pickUpDateExpired() {
      return (utcPickUpDate) => {
        if (this.userType === "TenantUser") {
          return true;
        } else {
          return this.$helper.isNotExpiredDate(utcPickUpDate);
        }
      };
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      jobBrowserDateRange: null,
      allPermissions: [],
      defaultPageSize: 0,
      // period: "today",
      period: "today",
      progress: "all",
      items: [],
      reasons: [],
      abortModel: { reasonCode: null, reasonWord: null },
      totalAllJobs: 0,
      totalJobsOpen: 0,
      totalJobsRun: 0,
      totalJobsUnderReview: 0,
      totalJobsDone: 0,
      totalJobsClose: 0,
      totalJobsAborted: 0,
      totalJobsRescued: 0,
      selectedProvider: {},
      reservationId: null,
      isAbortAlowed: false,
      preferredProviders: [],
      isLoading: false,
      msg: "Please wait",
      userType: "Unspecified",
      searchProvider: "",
      hasProvider: false,
      providerId: "",
      pathAcceptAmendment: {
        reservationId: "",
        amendmentId: "",
      },
    };
  },
  validations() {
    return {
      abortModel: {
        reasonCode: { required },
        reasonWord: { required, maxLength: maxLength(300) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );
    this.defaultPageSize = this.table.pageSize;

    const profile = await this.$store.dispatch("user/getProfile");
    this.userType = profile.userType;
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      this.reasons = [
        { value: "1", text: "Entered wrong location" },
        { value: "2", text: "Changes to the travel plans " },
        { value: "3", text: "Not enough space in the vehicle " },
        { value: "4", text: "Entered wrong information" },
        { value: "5", text: "Others" },
      ];

      await Promise.all([
        this.countAll(),
        this.getAll(this.period, this.progress),
      ]);
    }
  },
  updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("tenant-job-browser-link");
    $("#jobBrowserDateRange-input").addClass("borderless-jobBrowserDateRange");
  },
  methods: {
    startLoader() {
      this.isLoading = true;
    },
    stopLoader() {
      this.isLoading = false;
    },
    openModalAcceptAmendment(item) {
      this.pathAcceptAmendment = {
        reservationId: item.reservationId,
        amendmentId: item.amendConfirmationId,
      };
      $("#AcceptAmendment").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async handleAcceptAmendment(state) {
      const payload = { state: state };
      const url = `${this.pathAcceptAmendment.reservationId}/amend/${this.pathAcceptAmendment.amendmentId}/respond`;
      const response = await reservationService.acceptAmendment(
        payload,
        url,
        this.startLoader,
        this.stopLoader,
        this.overrideAcceptAmendment
      );
      if (response && response.isSuccess) {
        this.$notification.success(
          state === 1
            ? "Accept amendment successfully"
            : "Decline amendment successfully",
          {
            title: "Success",
          }
        );
        this.getAll(this.period, this.progress);
      }
    },
    overrideAcceptAmendment(data) {
      if (
        this.userType === "TenantUser" &&
        data.errors[0].includes("JTB001|")
      ) {
        $("#OverrideAcceptAmendment").modal({
          backdrop: "static",
          keyboard: false,
        });
      }
    },
    async handleBackToRun(reservationId) {
      this.isLoading = true;
      try {
        const response = await tripLogJobService.backToRunStatus(reservationId);
        if (response.isSuccess) {
          this.isLoading = false;
          this.getAll(this.period, this.progress);
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll(this.period, this.progress);
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll(self.period, self.progress);
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll(this.period, this.progress);
    },
    isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    async changeProgress(progress) {
      this.table.keyword = "";
      this.table.pageNumber = 1;
      this.table.pageSize = this.defaultPageSize;
      this.progress = progress;
      await this.getAll(this.period, this.progress);
    },
    async changePeriods(period) {
      this.period = period;
      await Promise.all([
        this.countAll(),
        this.getAll(this.period, this.progress, true),
      ]);
    },
    async getAll(period, progress, clear = false) {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        if (clear) this.table.pageNumber = 1;
        this.isLoading = true;
        this.items = [];
        this.period = period;
        this.progress = progress;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        filter += `&data=${this.progress};0;${this.convertPeriod()}`;
        const response = await inquiryTenantJobService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async countAll() {
      try {
        const response = await inquiryTenantJobService.countAll(
          this.convertPeriod(),
          0
        );
        this.totalAllJobs = response.data.totalAllJobs;
        this.totalJobsOpen = response.data.totalJobsOpen;
        this.totalJobsRun = response.data.totalJobsRun;
        this.totalJobsUnderReview = response.data.totalJobsUnderReview;
        this.totalJobsDone = response.data.totalJobsDone;
        this.totalJobsClose = response.data.totalJobsClose;
        this.totalJobsAborted = response.data.totalJobsAborted;
        this.totalJobsRescued = response.data.totalJobsRescued;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    isAllowCompleteJob(job) {
      const hasPassed = new Date() > new Date(job.utcDropOffDate);
      return job.hasProvider && job.hasVehicle && job.hasDriver && hasPassed;
    },
    isAllowAcceptAmendment(job) {
      return job.amendConfirmationId !== null;
    },
    async openModalCompleteTrip(value) {
      try {
        this.isLoading = true;
        const reservation = await inquiryTenantJobService.getDetail(
          value.reservationId
        );
        const response = await inquiryTenantJobService.getAvailableCurrency(
          value.reservationId
        );
        this.$eventBus.$emit(
          "completeTrip",
          value,
          response.data,
          reservation.moneyFormat
        );
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getPreferredProviders(item) {
      try {
        this.isLoading = true;
        this.searchProvider = "";
        this.preferredProviders =
          await inquiryTenantJobService.getPreferredProviders(
            item.reservationId
          );
        this.reservationId = item.reservationId;
        this.hasProvider = item.hasProvider;
        this.isAbortAlowed =
          this.preferredProviders.find((x) => x.isDispatchAllowed) !== null;
        $(this.$refs.tenant_event_modal).modal({
          backdrop: "static",
          keyboard: false,
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async reassignPreferredProvider(providerId, overrideTimingBlock = false) {
      this.providerId = providerId;

      const payload = {
        providerId: providerId,
        overrideTimingBlock: overrideTimingBlock,
      };

      const response = await availableJobService.reassignProvider(
        this.reservationId,
        payload,
        this.startLoader,
        this.stopLoader,
        this.overrideModal
      );

      if (response && response.isSuccess) {
        this.$notification.success("Successfully re-assign provider.", {
          title: "Success",
        });
        $(this.$refs.tenant_event_modal).modal("hide");
        this.deleteReservationOnFirebase(this.reservationId);
        this.getAll(this.period, this.progress);
      }
    },
    overrideModal(data) {
      if (
        this.userType === "TenantUser" &&
        data.errors[0].includes("JTB001|")
      ) {
        $("#OverrideConfirmation").modal({
          backdrop: "static",
          keyboard: false,
        });
      }
    },
    openManualDispatchDialog(item) {
      this.searchProvider = "";
      this.selectedProvider = item;
      $("#DispatchProviderConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async manualDispatch(overrideTimingBlock = false) {
      try {
        this.isLoading = true;
        await inquiryTenantJobService.manualDispatch({
          reservationId: this.reservationId,
          providerId: this.selectedProvider.providerId,
          overrideTimingBlock: overrideTimingBlock,
        });
        await this.getAll(this.period, this.progress);
        $(this.$refs.tenant_event_modal).modal("hide");
        this.$notification.success("Successfully dispatched.", {
          title: "Success",
          position: "topCenter",
        });
      } catch (error) {
        if (
          this.userType === "TenantUser" &&
          error.errors[0].includes("JTB001|")
        ) {
          $("#OverrideDispatchConfirmation").modal({
            backdrop: "static",
            keyboard: false,
          });
        } else {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openReleaseProviderDialog(item) {
      this.selectedProvider = item;
      $("#ReleaseProviderConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async releaseProvider() {
      try {
        this.isLoading = true;
        await inquiryTenantJobService.releaseProvider({
          reservationId: this.reservationId,
          providerId: this.selectedProvider.providerId,
        });

        await Promise.all([
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.tenant_event_modal).modal("hide");
        this.$notification.success("Successfully released.", {
          title: "Success",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.deleteReservationOnFirebase(this.reservationId);
      }
    },
    // deleteReservationOnFirebase(reservationId) {
    //   firebaseDB.ref("locations/" + reservationId).remove();
    // },
    async deleteReservationOnFirebase(reservationId) {
      try {
        await firebaseDB.ref(`locations/${reservationId}`).remove();
        console.log("Firebase location deleted:", reservationId);
      } catch (error) {
        console.error("Failed to delete Firebase location:", {
          reservationId,
          error,
        });
      }
    },
    openAbortReservationDialog(item) {
      this.reservationId = item.reservationId;
      $("#AbortReservationConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    onClickReasonCode(item) {
      this.abortModel.reasonCode = item.value;
      this.abortModel.reasonWord = item.value === "5" ? null : item.text;
    },
    openCancelReasonDialog() {
      this.resetValidation();
      this.onClickReasonCode(this.reasons[0]);
      $(this.$refs.cancelreasonmodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    resetValidation() {
      this.isSubmitted = false;
      this.$v.abortModel.$reset();
    },
    async abort() {
      let reservationId = this.reservationId;
      this.isSubmitted = true;
      this.$v.abortModel.$touch();
      if (this.$v.abortModel.$error) {
        return;
      }
      try {
        this.isLoading = true;
        await inquiryTenantJobService.abort({
          reason: this.abortModel.reasonWord,
          reservationId: this.reservationId,
        });

        await Promise.all([
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        this.resetValidation();
        $(this.$refs.cancelreasonmodal).modal("hide");
        this.$notification.success("Successfully aborted", {
          title: "Success",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.deleteReservationOnFirebase(reservationId);
      }
    },
    viewReservationReprice(item) {
      // publish message
      this.$eventBus.$emit("initializeReservationReprice", item);
    },
    canReprice(item) {
      if (item.progress != "Done") {
        return false;
      }
      return true;
    },
    convertPeriod() {
      let result = "";
      const date = new Date();
      switch (this.period.toLowerCase()) {
        case "all":
          this.jobBrowserDateRange = null;
          result = "all";
          break;
        case "today":
          this.jobBrowserDateRange = null;
          result = `today_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "tomorrow":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 1);
          result = `tomorrow_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "next":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 2);
          result = `next_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "range":
          result = `range_${this.jobBrowserDateRange.start}_${this.jobBrowserDateRange.end}`;
          break;
      }
      return result;
    },
    getLastState(item) {
      if (item.hasDriver && item.hasVehicle) {
        return "Driver & Vehicle Assigned";
      } else {
        return item.lastState;
      }
    },
    shortenString(item, textToBeReplaced) {
      return item.replace(textToBeReplaced, "");
    },
    showPicker() {
      $(".tabs-inquiry").removeClass("sticky");
    },
    hidePicker() {
      $(".tabs-inquiry").addClass("sticky");
    },
    async searchRange() {
      if (
        !this.jobBrowserDateRange.start ||
        this.jobBrowserDateRange.start === "" ||
        !this.jobBrowserDateRange.end ||
        this.jobBrowserDateRange.end === ""
      ) {
        alert("Please select a date range.");
        return;
      }
      this.hidePicker();
      await this.changePeriods("range");
    },
    printRequestedAncillaries(requestedAncillaries) {
      if (requestedAncillaries && requestedAncillaries.length > 0) {
        let result = "";
        for (let i = 0; i < requestedAncillaries.length; i++) {
          const ancillary = requestedAncillaries[i];
          if (ancillary.isAvailable) {
            result += `<span>${ancillary.name}</span>`;
          } else {
            result += `<span class="sts-danger">*${ancillary.name}</span>`;
          }

          if (i < requestedAncillaries.length - 1) {
            result += ", ";
          }
        }
        return result;
      } else {
        return "No Ancillary Selected";
      }
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    cancelConfirmation() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
  },
};
</script>
<style scoped>
.provider-search {
  margin: 20px 0;
}

.provider-search .dataTables_filter input {
  width: 60%;
}

.badge-preferred-provider {
  padding: 5px 10px;
  background: #4fb848;
  border-radius: 5px;
  margin-left: 5px;
  color: #fff;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/job/tenantJob/TenantJob.vue